import { render, staticRenderFns } from "./TextJsonEdit.vue?vue&type=template&id=3104a1da&scoped=true&"
import script from "./TextJsonEdit.vue?vue&type=script&lang=ts&"
export * from "./TextJsonEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3104a1da",
  null
  
)

export default component.exports